/**
 * schedulesData
 */
export interface schedulesData {
    /**
     * stateId
     */
    stateId: number | null;
    /**
     * active
     */
    active: string | null;
    /**
     * count
     */
    count: string | null;
    /**
     * objectid
     */
    objectid: string | null;
    /**
     * objectname
     */
    objectname: string | null;
}
